import React from 'react'
import './SplashScreen.css'
import { Container } from 'react-bootstrap';
/*
import { Container, Row, Col, Card } from 'react-bootstrap';
import MillenniumCity1 from "../images/MillenniumCity1.png";
import MillenniumCity2 from "../images/MillenniumCity2.png";
import MillenniumCity5 from "../images/MillenniumCity5.png";
import MillenniumCity6 from "../images/MillenniumCity6.png";
*/


const SplashScreen = () => {
  return (
    <React.Fragment>
      <div className="splash-screen">
        <Container>
{/*
          <Row style={{marginTop:'0px'}}>
            <Col>
              <Card style={{border:'0', margin:'auto', width:'400px', boxShadow:'0 10px 10px 0px rgba(0,0,0,0.5)'}}>
                <img src={MillenniumCity1} alt={'SHKP'}/>
              </Card>
            </Col>
            <Col>
              <Card style={{border:'0', margin:'auto', width:'400px', boxShadow:'0 10px 10px 0px rgba(0,0,0,0.5)'}}>
                <img src={MillenniumCity2} alt={'SHKP'}/>
              </Card>
            </Col>
          </Row>
          <Row style={{marginTop:'50px'}}>
            <Col>
              <Card style={{border:'0', margin:'auto', width:'400px', boxShadow:'0 10px 10px 0px rgba(0,0,0,0.5)'}}>
                <img src={MillenniumCity5} alt={'SHKP'}/>
              </Card>
            </Col>
            <Col>
              <Card style={{border:'0', margin:'auto', width:'400px', boxShadow:'0 10px 10px 0px rgba(0,0,0,0.5)'}}>
                <img src={MillenniumCity6} alt={'SHKP'}/>
              </Card>
            </Col>
          </Row>
*/}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SplashScreen;
